module.exports = __webpack_public_path__ + "img/invoice.bfe94bf4.png";